// import React, { useEffect, useState } from "react";
// import {
//   Alert,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Chip,
//   CircularProgress,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   MenuItem,
//   Snackbar,
//   Stack,
//   Switch,
//   TextField,
//   Typography,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import HomeIcon from "@mui/icons-material/Home";
// import StarIcon from "@mui/icons-material/Star";
// import ApiServices from "../../Utils/ApiServices";

// const emptyAddress = {
//   label: "home",
//   recipient_name: "",
//   recipient_phone: "",
//   street_address: "",
//   landmark: "",
//   city: "",
//   state: "",
//   pincode: "",
//   country: "India",
//   latitude: "",
//   longitude: "",
//   is_default: false,
// };

// const labels = ["home", "office", "shop", "other"];

// const CustomerAddress = ({ customerId, accessToken }) => {
//   const [addresses, setAddresses] = useState([]);
//   const [formData, setFormData] = useState(emptyAddress);
//   const [errors, setErrors] = useState({});
//   const [openForm, setOpenForm] = useState(false);
//   const [editingAddress, setEditingAddress] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const showMessage = (message, severity = "success") => {
//     setSnackbar({ open: true, message, severity });
//   };



//   const fetchAddresses = async () => {
//     if (!customerId || !accessToken) return;

//     try {
//       setLoading(true);

//       const res = await ApiServices.get(
//         `/api/v1/customers/${customerId}/addresses/`,
//         { Authorization: `Bearer ${accessToken}` }
//       );

//       const data = res?.data || res || [];
//       setAddresses(Array.isArray(data) ? data : []);
//     } catch (error) {
//       showMessage(
//         error?.response?.data?.detail || "Failed to load addresses.",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAddresses();
//   }, [customerId, accessToken]);

//   const validateAddress = () => {
//     const newErrors = {};

//     if (!formData.street_address.trim()) {
//       newErrors.street_address = "Street address is required";
//     }

//     if (!formData.city.trim()) {
//       newErrors.city = "City is required";
//     }

//     if (!formData.state.trim()) {
//       newErrors.state = "State is required";
//     }

//     if (!formData.pincode.trim()) {
//       newErrors.pincode = "Pincode is required";
//     } else if (!/^\d{5,6}$/.test(formData.pincode.trim())) {
//       newErrors.pincode = "Enter a valid 5 or 6 digit pincode";
//     }

//     if (!formData.country.trim()) {
//       newErrors.country = "Country is required";
//     }

//     if (
//       formData.recipient_phone.trim() &&
//       !/^[6-9]\d{9}$/.test(formData.recipient_phone.trim())
//     ) {
//       newErrors.recipient_phone = "Enter valid 10 digit Indian mobile number";
//     }

//     if (formData.latitude && isNaN(Number(formData.latitude))) {
//       newErrors.latitude = "Latitude must be a valid number";
//     }

//     if (formData.longitude && isNaN(Number(formData.longitude))) {
//       newErrors.longitude = "Longitude must be a valid number";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleOpenAdd = () => {
//     setEditingAddress(null);
//     setFormData(emptyAddress);
//     setErrors({});
//     setOpenForm(true);
//   };

//   const handleOpenEdit = (address) => {
//     setEditingAddress(address);
//     setFormData({
//       label: address.label || "home",
//       recipient_name: address.recipient_name || "",
//       recipient_phone: address.recipient_phone || "",
//       street_address: address.street_address || "",
//       landmark: address.landmark || "",
//       city: address.city || "",
//       state: address.state || "",
//       pincode: address.pincode || "",
//       country: address.country || "India",
//       latitude: address.latitude || "",
//       longitude: address.longitude || "",
//       is_default: Boolean(address.is_default),
//     });
//     setErrors({});
//     setOpenForm(true);
//   };

//   const handleCloseForm = () => {
//     setOpenForm(false);
//     setEditingAddress(null);
//     setFormData(emptyAddress);
//     setErrors({});
//   };

//   const handleChange = (e) => {
//     const { name, value, checked, type } = e.target;

//     let finalValue = type === "checkbox" ? checked : value;

//     if (name === "pincode") {
//       finalValue = value.replace(/\D/g, "").slice(0, 6);
//     }

//     if (name === "recipient_phone") {
//       finalValue = value.replace(/\D/g, "").slice(0, 10);
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: finalValue,
//     }));

//     setErrors((prev) => ({
//       ...prev,
//       [name]: "",
//     }));
//   };

//   const preparePayload = () => {
//     const payload = {
//       label: formData.label,
//       recipient_name: formData.recipient_name.trim(),
//       recipient_phone: formData.recipient_phone.trim(),
//       street_address: formData.street_address.trim(),
//       landmark: formData.landmark.trim(),
//       city: formData.city.trim(),
//       state: formData.state.trim(),
//       pincode: formData.pincode.trim(),
//       country: formData.country.trim() || "India",
//       is_default: formData.is_default,
//     };

//     if (formData.latitude !== "") {
//       payload.latitude = Number(formData.latitude);
//     }

//     if (formData.longitude !== "") {
//       payload.longitude = Number(formData.longitude);
//     }

//     return payload;
//   };

//   const handleSaveAddress = async () => {
//     if (!validateAddress()) return;

//     try {
//       setSaving(true);

//       const payload = preparePayload();

//       if (editingAddress) {
//         await ApiServices.patch(
//           `/api/v1/customers/${customerId}/addresses/${editingAddress.id}/`,
//           payload,
//           { Authorization: `Bearer ${accessToken}` }
//         );

//         showMessage("Address updated successfully.", "success");
//       } else {
//         await ApiServices.post(
//           `/api/v1/customers/${customerId}/addresses/`,
//           payload,
//           { Authorization: `Bearer ${accessToken}` }
//         );

//         showMessage("Address added successfully.", "success");
//       }

//       handleCloseForm();
//       fetchAddresses();
//     } catch (error) {
//       showMessage(
//         error?.response?.data?.detail || "Failed to save address.",
//         "error"
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDeleteAddress = async (addressId) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this address?"
//     );

//     if (!confirmDelete) return;

//     try {
//       await ApiServices.delete(
//         `/api/v1/customers/${customerId}/addresses/${addressId}/`,
//         { Authorization: `Bearer ${accessToken}` }
//       );

//       showMessage("Address deleted successfully.", "success");
//       fetchAddresses();
//     } catch (error) {
//       showMessage(
//         error?.response?.data?.detail || "Failed to delete address.",
//         "error"
//       );
//     }
//   };

//   const handleSetDefault = async (addressId) => {
//     try {
//       await ApiServices.post(
//         `/api/v1/customers/${customerId}/addresses/${addressId}/set-default/`,
//         {},
//         { Authorization: `Bearer ${accessToken}` }
//       );

//       showMessage("Default address updated successfully.", "success");
//       fetchAddresses();
//     } catch (error) {
//       showMessage(
//         error?.response?.data?.detail || "Failed to set default address.",
//         "error"
//       );
//     }
//   };

//   return (
//     <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
//       <CardContent sx={{ p: { xs: 2, md: 3 } }}>
//         <Stack
//           direction={{ xs: "column", sm: "row" }}
//           justifyContent="space-between"
//           alignItems={{ xs: "flex-start", sm: "center" }}
//           spacing={2}
//           sx={{ mb: 3 }}
//         >
//           <Box>
//             <Typography variant="h6" fontWeight={700}>
//               Saved Addresses
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               Add, update, delete and manage your default delivery address.
//             </Typography>
//           </Box>

//           <Button
//             variant="contained"
//             startIcon={<AddIcon />}
//             onClick={handleOpenAdd}
//           >
//             Add Address
//           </Button>
//         </Stack>

//         {loading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
//             <CircularProgress />
//           </Box>
//         ) : addresses.length === 0 ? (
//           <Alert severity="info">
//             No address found. Please add your first delivery address.
//           </Alert>
//         ) : (
//           <Grid container spacing={2}>
//             {addresses.map((address) => (
//               <Grid item xs={12} md={6} key={address.id}>
//                 <Card
//                   variant="outlined"
//                   sx={{
//                     borderRadius: 3,
//                     height: "100%",
//                     borderColor: address.is_default
//                       ? "primary.main"
//                       : "divider",
//                   }}
//                 >
//                   <CardContent>
//                     <Stack
//                       direction="row"
//                       justifyContent="space-between"
//                       alignItems="flex-start"
//                       spacing={1}
//                     >
//                       <Box>
//                         <Stack direction="row" spacing={1} alignItems="center">
//                           <HomeIcon color="primary" />
//                           <Typography
//                             variant="subtitle1"
//                             fontWeight={700}
//                             sx={{ textTransform: "capitalize" }}
//                           >
//                             {address.label}
//                           </Typography>

//                           {address.is_default && (
//                             <Chip
//                               size="small"
//                               color="primary"
//                               icon={<StarIcon />}
//                               label="Default"
//                             />
//                           )}
//                         </Stack>

//                         <Typography sx={{ mt: 1 }}>
//                           {address.street_address}
//                         </Typography>

//                         {address.landmark && (
//                           <Typography color="text.secondary">
//                             Landmark: {address.landmark}
//                           </Typography>
//                         )}

//                         <Typography color="text.secondary">
//                           {address.city}, {address.state} - {address.pincode}
//                         </Typography>

//                         <Typography color="text.secondary">
//                           {address.country}
//                         </Typography>

//                         {(address.recipient_name || address.recipient_phone) && (
//                           <>
//                             <Divider sx={{ my: 1.5 }} />
//                             <Typography variant="body2">
//                               Recipient: {address.recipient_name || "-"}
//                             </Typography>
//                             <Typography variant="body2">
//                               Phone: {address.recipient_phone || "-"}
//                             </Typography>
//                           </>
//                         )}
//                       </Box>

//                       <Stack direction="row">
//                         <IconButton onClick={() => handleOpenEdit(address)}>
//                           <EditIcon />
//                         </IconButton>

//                         <IconButton
//                           color="error"
//                           onClick={() => handleDeleteAddress(address.id)}
//                         >
//                           <DeleteIcon />
//                         </IconButton>
//                       </Stack>
//                     </Stack>

//                     {!address.is_default && (
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         sx={{ mt: 2 }}
//                         onClick={() => handleSetDefault(address.id)}
//                       >
//                         Set as Default
//                       </Button>
//                     )}
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         )}
//       </CardContent>

//       <Dialog open={openForm} onClose={handleCloseForm} maxWidth="md" fullWidth>
//         <DialogTitle>
//           {editingAddress ? "Update Address" : "Add New Address"}
//         </DialogTitle>

//         <DialogContent dividers>
//           <Grid container spacing={2} sx={{ mt: 0.5 }}>
//             <Grid item xs={12} sm={4}>
//               <TextField
//                 select
//                 fullWidth
//                 label="Address Label"
//                 name="label"
//                 value={formData.label}
//                 onChange={handleChange}
//               >
//                 {labels.map((item) => (
//                   <MenuItem key={item} value={item}>
//                     {item.charAt(0).toUpperCase() + item.slice(1)}
//                   </MenuItem>
//                 ))}
//               </TextField>
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <TextField
//                 fullWidth
//                 label="Recipient Name"
//                 name="recipient_name"
//                 value={formData.recipient_name}
//                 onChange={handleChange}
//                 helperText="Optional"
//               />
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <TextField
//                 fullWidth
//                 label="Recipient Phone"
//                 name="recipient_phone"
//                 value={formData.recipient_phone}
//                 onChange={handleChange}
//                 error={Boolean(errors.recipient_phone)}
//                 helperText={errors.recipient_phone || "Optional"}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 minRows={2}
//                 label="Street Address"
//                 name="street_address"
//                 value={formData.street_address}
//                 onChange={handleChange}
//                 error={Boolean(errors.street_address)}
//                 helperText={errors.street_address}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Landmark"
//                 name="landmark"
//                 value={formData.landmark}
//                 onChange={handleChange}
//                 helperText="Optional"
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="City"
//                 name="city"
//                 value={formData.city}
//                 onChange={handleChange}
//                 error={Boolean(errors.city)}
//                 helperText={errors.city}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <TextField
//                 fullWidth
//                 label="State"
//                 name="state"
//                 value={formData.state}
//                 onChange={handleChange}
//                 error={Boolean(errors.state)}
//                 helperText={errors.state}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <TextField
//                 fullWidth
//                 label="Pincode"
//                 name="pincode"
//                 value={formData.pincode}
//                 onChange={handleChange}
//                 error={Boolean(errors.pincode)}
//                 helperText={errors.pincode}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <TextField
//                 fullWidth
//                 label="Country"
//                 name="country"
//                 value={formData.country}
//                 onChange={handleChange}
//                 error={Boolean(errors.country)}
//                 helperText={errors.country}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Latitude"
//                 name="latitude"
//                 value={formData.latitude}
//                 onChange={handleChange}
//                 error={Boolean(errors.latitude)}
//                 helperText={errors.latitude || "Optional"}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Longitude"
//                 name="longitude"
//                 value={formData.longitude}
//                 onChange={handleChange}
//                 error={Boolean(errors.longitude)}
//                 helperText={errors.longitude || "Optional"}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <FormControlLabel
//                 control={
//                   <Switch
//                     checked={formData.is_default}
//                     name="is_default"
//                     onChange={handleChange}
//                   />
//                 }
//                 label="Set as default address"
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>

//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={handleCloseForm}>Cancel</Button>
//           <Button
//             variant="contained"
//             onClick={handleSaveAddress}
//             disabled={saving}
//           >
//             {saving ? "Saving..." : editingAddress ? "Update Address" : "Add Address"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3500}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert
//           severity={snackbar.severity}
//           variant="filled"
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Card>
//   );
// };

// export default CustomerAddress;


import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Snackbar,
  Stack,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import WorkRoundedIcon from "@mui/icons-material/WorkRounded";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import PlaceRoundedIcon from "@mui/icons-material/PlaceRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";
import LocationCityRoundedIcon from "@mui/icons-material/LocationCityRounded";
import PinDropRoundedIcon from "@mui/icons-material/PinDropRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import MyLocationRoundedIcon from "@mui/icons-material/MyLocationRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import LocalPizzaRoundedIcon from "@mui/icons-material/LocalPizzaRounded";
import ApiServices from "../../Utils/ApiServices";

const REDGRAD =
  "linear-gradient(135deg, #7A0E0E 0%, #B71C1C 50%, #E64A19 100%)";
const AMBERGRAD =
  "linear-gradient(135deg, #FF8F00 0%, #FFB300 50%, #FFC107 100%)";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2.5,
    backgroundColor: "#FFF8F0",
    transition: "all .25s ease",
    "& fieldset": { borderColor: "rgba(122,14,14,0.18)" },
    "&:hover fieldset": { borderColor: "#E64A19" },
    "&.Mui-focused fieldset": { borderColor: "#B71C1C", borderWidth: 2 },
    "&.Mui-focused": {
      boxShadow: "0 0 0 4px rgba(183,28,28,0.10)",
      backgroundColor: "#fff",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: "#B71C1C" },
};

const emptyAddress = {
  label: "home",
  recipient_name: "",
  recipient_phone: "",
  street_address: "",
  landmark: "",
  city: "",
  state: "",
  pincode: "",
  country: "India",
  latitude: "",
  longitude: "",
  is_default: false,
};

const labels = ["home", "office", "shop", "other"];

const labelIcon = (label) => {
  switch (label) {
    case "home":
      return <HomeRoundedIcon sx={{ fontSize: 18 }} />;
    case "office":
      return <WorkRoundedIcon sx={{ fontSize: 18 }} />;
    case "shop":
      return <StorefrontRoundedIcon sx={{ fontSize: 18 }} />;
    default:
      return <PlaceRoundedIcon sx={{ fontSize: 18 }} />;
  }
};

const labelGradient = (label) => {
  switch (label) {
    case "home":
      return "linear-gradient(135deg,#B71C1C,#E64A19)";
    case "office":
      return "linear-gradient(135deg,#1565C0,#42A5F5)";
    case "shop":
      return "linear-gradient(135deg,#6A1B9A,#AB47BC)";
    default:
      return "linear-gradient(135deg,#455A64,#90A4AE)";
  }
};

const CustomerAddress = ({ customerId, accessToken }) => {
  const [addresses, setAddresses] = useState([]);
  const [formData, setFormData] = useState(emptyAddress);
  const [errors, setErrors] = useState({});
  const [openForm, setOpenForm] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showMessage = (message, severity = "success") =>
    setSnackbar({ open: true, message, severity });

  const fetchAddresses = async () => {
    if (!customerId || !accessToken) return;
    try {
      setLoading(true);
      const res = await ApiServices.get(
        `/api/v1/customers/${customerId}/addresses/`,
        { Authorization: `Bearer ${accessToken}` }
      );
      const data = res?.data || res || [];
      setAddresses(Array.isArray(data) ? data : []);
    } catch (error) {
      showMessage(
        error?.response?.data?.detail || "Failed to load addresses.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, accessToken]);

  const validateAddress = () => {
    const newErrors = {};
    if (!formData.street_address.trim())
      newErrors.street_address = "Street address is required";
    if (!formData.city.trim()) newErrors.city = "City is required";
    if (!formData.state.trim()) newErrors.state = "State is required";
    if (!formData.pincode.trim()) newErrors.pincode = "Pincode is required";
    else if (!/^\d{5,6}$/.test(formData.pincode.trim()))
      newErrors.pincode = "Enter a valid 5 or 6 digit pincode";
    if (!formData.country.trim()) newErrors.country = "Country is required";
    if (
      formData.recipient_phone.trim() &&
      !/^[6-9]\d{9}$/.test(formData.recipient_phone.trim())
    )
      newErrors.recipient_phone = "Enter valid 10 digit Indian mobile number";
    if (formData.latitude && isNaN(Number(formData.latitude)))
      newErrors.latitude = "Latitude must be a valid number";
    if (formData.longitude && isNaN(Number(formData.longitude)))
      newErrors.longitude = "Longitude must be a valid number";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleOpenAdd = () => {
    setEditingAddress(null);
    setFormData(emptyAddress);
    setErrors({});
    setOpenForm(true);
  };

  const handleOpenEdit = (address) => {
    setEditingAddress(address);
    setFormData({
      label: address.label || "home",
      recipient_name: address.recipient_name || "",
      recipient_phone: address.recipient_phone || "",
      street_address: address.street_address || "",
      landmark: address.landmark || "",
      city: address.city || "",
      state: address.state || "",
      pincode: address.pincode || "",
      country: address.country || "India",
      latitude: address.latitude || "",
      longitude: address.longitude || "",
      is_default: Boolean(address.is_default),
    });
    setErrors({});
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setEditingAddress(null);
    setFormData(emptyAddress);
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    let finalValue = type === "checkbox" ? checked : value;
    if (name === "pincode") finalValue = value.replace(/\D/g, "").slice(0, 6);
    if (name === "recipient_phone")
      finalValue = value.replace(/\D/g, "").slice(0, 10);

    setFormData((prev) => ({ ...prev, [name]: finalValue }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const preparePayload = () => {
    const payload = {
      label: formData.label,
      recipient_name: formData.recipient_name.trim(),
      recipient_phone: formData.recipient_phone.trim(),
      street_address: formData.street_address.trim(),
      landmark: formData.landmark.trim(),
      city: formData.city.trim(),
      state: formData.state.trim(),
      pincode: formData.pincode.trim(),
      country: formData.country.trim() || "India",
      is_default: formData.is_default,
    };
    if (formData.latitude !== "") payload.latitude = Number(formData.latitude);
    if (formData.longitude !== "")
      payload.longitude = Number(formData.longitude);
    return payload;
  };

  const handleSaveAddress = async () => {
    if (!validateAddress()) return;
    try {
      setSaving(true);
      const payload = preparePayload();
      if (editingAddress) {
        await ApiServices.patch(
          `/api/v1/customers/${customerId}/addresses/${editingAddress.id}/`,
          payload,
          { Authorization: `Bearer ${accessToken}` }
        );
        showMessage("Address updated successfully.", "success");
      } else {
        await ApiServices.post(
          `/api/v1/customers/${customerId}/addresses/`,
          payload,
          { Authorization: `Bearer ${accessToken}` }
        );
        showMessage("Address added successfully.", "success");
      }
      handleCloseForm();
      fetchAddresses();
    } catch (error) {
      showMessage(
        error?.response?.data?.detail || "Failed to save address.",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteAddress = async (addressId) => {
    if (!window.confirm("Are you sure you want to delete this address?"))
      return;
    try {
      await ApiServices.delete(
        `/api/v1/customers/${customerId}/addresses/${addressId}/`,
        { Authorization: `Bearer ${accessToken}` }
      );
      showMessage("Address deleted successfully.", "success");
      fetchAddresses();
    } catch (error) {
      showMessage(
        error?.response?.data?.detail || "Failed to delete address.",
        "error"
      );
    }
  };

  const handleSetDefault = async (addressId) => {
    try {
      await ApiServices.post(
        `/api/v1/customers/${customerId}/addresses/${addressId}/set-default/`,
        {},
        { Authorization: `Bearer ${accessToken}` }
      );
      showMessage("Default address updated successfully.", "success");
      fetchAddresses();
    } catch (error) {
      showMessage(
        error?.response?.data?.detail || "Failed to set default address.",
        "error"
      );
    }
  };

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: "none",
        background: "transparent",
      }}
    >
      <CardContent sx={{ p: { xs: 1.5, md: 2.5 } }}>
        {/* Header */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={2}
          sx={{ mb: 3 }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: "14px",
                background: REDGRAD,
                display: "grid",
                placeItems: "center",
                boxShadow: "0 8px 20px rgba(183,28,28,0.30)",
              }}
            >
              <PlaceRoundedIcon sx={{ color: "#fff" }} />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontFamily: "'Playfair Display', serif",
                  fontWeight: 800,
                  fontSize: { xs: 22, md: 26 },
                  color: "#2A1810",
                  lineHeight: 1.1,
                }}
              >
                Saved Addresses
              </Typography>
              <Typography sx={{ color: "#6b4a3a", fontSize: 13 }}>
                Add, update and manage your delivery addresses
              </Typography>
            </Box>
          </Stack>

          <Box
            component={motion.div}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.97 }}
          >
            <Button
              onClick={handleOpenAdd}
              startIcon={<AddRoundedIcon />}
              sx={{
                px: 3,
                py: 1.2,
                borderRadius: 999,
                color: "#fff",
                fontWeight: 700,
                background: REDGRAD,
                boxShadow: "0 12px 26px rgba(183,28,28,0.32)",
                "&:hover": {
                  background: REDGRAD,
                  boxShadow: "0 16px 34px rgba(183,28,28,0.45)",
                },
              }}
            >
              Add Address
            </Button>
          </Box>
        </Stack>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress sx={{ color: "#B71C1C" }} />
          </Box>
        ) : addresses.length === 0 ? (
          <Box
            sx={{
              textAlign: "center",
              py: 6,
              px: 3,
              borderRadius: 3,
              background:
                "linear-gradient(135deg, rgba(255,179,0,0.10), rgba(230,74,25,0.08))",
              border: "1px dashed rgba(230,74,25,0.35)",
            }}
          >
            <LocalPizzaRoundedIcon sx={{ fontSize: 56, color: "#E64A19", mb: 1 }} />
            <Typography fontWeight={800} sx={{ color: "#7A0E0E", fontSize: 18 }}>
              No addresses yet
            </Typography>
            <Typography sx={{ color: "#6b4a3a", mt: 0.5, fontSize: 14 }}>
              Add your first delivery address to start ordering hot pizzas 🍕
            </Typography>
            <Button
              onClick={handleOpenAdd}
              startIcon={<AddRoundedIcon />}
              sx={{
                mt: 2.5,
                px: 3,
                py: 1,
                borderRadius: 999,
                color: "#fff",
                fontWeight: 700,
                background: REDGRAD,
                "&:hover": { background: REDGRAD },
              }}
            >
              Add Address
            </Button>
          </Box>
        ) : (
          <Grid container spacing={2.5}>
            <AnimatePresence>
              {addresses.map((address, idx) => (
                <Grid item xs={12} md={6} key={address.id}>
                  <motion.div
                    initial={{ opacity: 0, y: 18 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.35, delay: idx * 0.05 }}
                    whileHover={{ y: -4 }}
                  >
                    <Card
                      sx={{
                        borderRadius: 3,
                        height: "100%",
                        position: "relative",
                        overflow: "hidden",
                        border: address.is_default
                          ? "2px solid transparent"
                          : "1px solid rgba(122,14,14,0.10)",
                        background: address.is_default
                          ? "linear-gradient(#fff,#fff) padding-box, linear-gradient(135deg,#FFB300,#E64A19) border-box"
                          : "#fff",
                        boxShadow: address.is_default
                          ? "0 18px 36px rgba(230,74,25,0.18)"
                          : "0 10px 24px rgba(122,14,14,0.08)",
                        transition: "all .25s ease",
                      }}
                    >
                      {/* Top accent strip */}
                      <Box
                        sx={{
                          height: 4,
                          background: labelGradient(address.label),
                        }}
                      />

                      <CardContent sx={{ p: 2.5 }}>
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="flex-start"
                          spacing={1}
                        >
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                              flexWrap="wrap"
                              useFlexGap
                            >
                              <Chip
                                icon={
                                  <Box sx={{ color: "#fff !important", display: "flex" }}>
                                    {labelIcon(address.label)}
                                  </Box>
                                }
                                label={
                                  address.label?.charAt(0).toUpperCase() +
                                  address.label?.slice(1)
                                }
                                sx={{
                                  background: labelGradient(address.label),
                                  color: "#fff",
                                  fontWeight: 700,
                                  height: 28,
                                  "& .MuiChip-icon": { color: "#fff", ml: 0.5 },
                                }}
                              />

                              {address.is_default && (
                                <Chip
                                  icon={
                                    <StarRoundedIcon
                                      sx={{ color: "#7A0E0E !important" }}
                                    />
                                  }
                                  label="Default"
                                  sx={{
                                    background: AMBERGRAD,
                                    color: "#7A0E0E",
                                    fontWeight: 800,
                                    height: 28,
                                  }}
                                />
                              )}
                            </Stack>

                            <Typography
                              sx={{
                                mt: 1.5,
                                fontWeight: 600,
                                color: "#2A1810",
                                lineHeight: 1.45,
                              }}
                            >
                              {address.street_address}
                            </Typography>

                            {address.landmark && (
                              <Typography
                                sx={{ color: "#6b4a3a", fontSize: 13, mt: 0.3 }}
                              >
                                Landmark: {address.landmark}
                              </Typography>
                            )}

                            <Typography sx={{ color: "#6b4a3a", fontSize: 13 }}>
                              {address.city}, {address.state} - {address.pincode}
                            </Typography>
                            <Typography sx={{ color: "#6b4a3a", fontSize: 13 }}>
                              {address.country}
                            </Typography>

                            {(address.recipient_name ||
                              address.recipient_phone) && (
                              <>
                                <Divider sx={{ my: 1.5 }} />
                                <Stack
                                  direction="row"
                                  spacing={2}
                                  flexWrap="wrap"
                                  useFlexGap
                                >
                                  <Stack
                                    direction="row"
                                    spacing={0.5}
                                    alignItems="center"
                                    sx={{ color: "#6b4a3a" }}
                                  >
                                    <PersonOutlineRoundedIcon
                                      sx={{ fontSize: 16 }}
                                    />
                                    <Typography fontSize={13}>
                                      {address.recipient_name || "-"}
                                    </Typography>
                                  </Stack>
                                  <Stack
                                    direction="row"
                                    spacing={0.5}
                                    alignItems="center"
                                    sx={{ color: "#6b4a3a" }}
                                  >
                                    <PhoneIphoneRoundedIcon
                                      sx={{ fontSize: 16 }}
                                    />
                                    <Typography fontSize={13}>
                                      {address.recipient_phone || "-"}
                                    </Typography>
                                  </Stack>
                                </Stack>
                              </>
                            )}
                          </Box>

                          <Stack direction="column" spacing={0.5}>
                            <Tooltip title="Edit">
                              <IconButton
                                onClick={() => handleOpenEdit(address)}
                                sx={{
                                  background:
                                    "linear-gradient(135deg, rgba(255,179,0,0.18), rgba(230,74,25,0.15))",
                                  color: "#B71C1C",
                                  "&:hover": {
                                    background: REDGRAD,
                                    color: "#fff",
                                  },
                                }}
                              >
                                <EditRoundedIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                              <IconButton
                                onClick={() => handleDeleteAddress(address.id)}
                                sx={{
                                  background: "rgba(244,67,54,0.10)",
                                  color: "#D32F2F",
                                  "&:hover": {
                                    background: "#D32F2F",
                                    color: "#fff",
                                  },
                                }}
                              >
                                <DeleteOutlineRoundedIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </Stack>

                        {!address.is_default && (
                          <Button
                            size="small"
                            onClick={() => handleSetDefault(address.id)}
                            startIcon={<StarRoundedIcon />}
                            sx={{
                              mt: 2,
                              borderRadius: 999,
                              px: 2,
                              fontWeight: 700,
                              color: "#7A0E0E",
                              border: "1.5px solid rgba(183,28,28,0.3)",
                              background: "rgba(255,179,0,0.08)",
                              "&:hover": {
                                background: AMBERGRAD,
                                borderColor: "transparent",
                                color: "#7A0E0E",
                              },
                            }}
                          >
                            Set as Default
                          </Button>
                        )}
                      </CardContent>
                    </Card>
                  </motion.div>
                </Grid>
              ))}
            </AnimatePresence>
          </Grid>
        )}
      </CardContent>

      {/* Form Dialog */}
      <Dialog
        open={openForm}
        onClose={handleCloseForm}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: "hidden",
            background:
              "linear-gradient(180deg, #FFFFFF 0%, #FFF8F0 100%)",
          },
        }}
      >
        <Box
          sx={{
            background: REDGRAD,
            color: "#fff",
            px: 3,
            py: 2.5,
            position: "relative",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <PlaceRoundedIcon />
            <DialogTitle
              sx={{
                p: 0,
                color: "#fff",
                fontFamily: "'Playfair Display', serif",
                fontWeight: 800,
                fontSize: 22,
              }}
            >
              {editingAddress ? "Update Address" : "Add New Address"}
            </DialogTitle>
          </Stack>
          <IconButton
            onClick={handleCloseForm}
            sx={{
              position: "absolute",
              right: 12,
              top: 12,
              color: "#fff",
              "&:hover": { background: "rgba(255,255,255,0.15)" },
            }}
          >
            <CloseRoundedIcon />
          </IconButton>
        </Box>

        <DialogContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
          <Grid container spacing={2.5} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={4}>
              <TextField
                select
                fullWidth
                label="Address Label"
                name="label"
                value={formData.label}
                onChange={handleChange}
                sx={inputSx}
              >
                {labels.map((item) => (
                  <MenuItem key={item} value={item}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      {labelIcon(item)}
                      <span>
                        {item.charAt(0).toUpperCase() + item.slice(1)}
                      </span>
                    </Stack>
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Recipient Name"
                name="recipient_name"
                value={formData.recipient_name}
                onChange={handleChange}
                helperText="Optional"
                sx={inputSx}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutlineRoundedIcon sx={{ color: "#B71C1C" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Recipient Phone"
                name="recipient_phone"
                value={formData.recipient_phone}
                onChange={handleChange}
                error={Boolean(errors.recipient_phone)}
                helperText={errors.recipient_phone || "Optional"}
                sx={inputSx}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneIphoneRoundedIcon sx={{ color: "#B71C1C" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                minRows={2}
                label="Street Address"
                name="street_address"
                value={formData.street_address}
                onChange={handleChange}
                error={Boolean(errors.street_address)}
                helperText={errors.street_address}
                sx={inputSx}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Landmark"
                name="landmark"
                value={formData.landmark}
                onChange={handleChange}
                helperText="Optional"
                sx={inputSx}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PlaceRoundedIcon sx={{ color: "#B71C1C" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                error={Boolean(errors.city)}
                helperText={errors.city}
                sx={inputSx}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationCityRoundedIcon sx={{ color: "#B71C1C" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="State"
                name="state"
                value={formData.state}
                onChange={handleChange}
                error={Boolean(errors.state)}
                helperText={errors.state}
                sx={inputSx}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Pincode"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
                error={Boolean(errors.pincode)}
                helperText={errors.pincode}
                sx={inputSx}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PinDropRoundedIcon sx={{ color: "#B71C1C" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Country"
                name="country"
                value={formData.country}
                onChange={handleChange}
                error={Boolean(errors.country)}
                helperText={errors.country}
                sx={inputSx}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PublicRoundedIcon sx={{ color: "#B71C1C" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Latitude"
                name="latitude"
                value={formData.latitude}
                onChange={handleChange}
                error={Boolean(errors.latitude)}
                helperText={errors.latitude || "Optional"}
                sx={inputSx}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MyLocationRoundedIcon sx={{ color: "#B71C1C" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Longitude"
                name="longitude"
                value={formData.longitude}
                onChange={handleChange}
                error={Boolean(errors.longitude)}
                helperText={errors.longitude || "Optional"}
                sx={inputSx}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MyLocationRoundedIcon sx={{ color: "#B71C1C" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: 2.5,
                  background:
                    "linear-gradient(135deg, rgba(255,179,0,0.10), rgba(230,74,25,0.08))",
                  border: "1px dashed rgba(230,74,25,0.3)",
                }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.is_default}
                      name="is_default"
                      onChange={handleChange}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#E64A19",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          { background: REDGRAD, opacity: 1 },
                      }}
                    />
                  }
                  label={
                    <Typography fontWeight={600} sx={{ color: "#7A0E0E" }}>
                      Set as default delivery address
                    </Typography>
                  }
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button
            onClick={handleCloseForm}
            sx={{
              px: 3,
              borderRadius: 999,
              color: "#7A0E0E",
              fontWeight: 700,
              "&:hover": { background: "rgba(122,14,14,0.06)" },
            }}
          >
            Cancel
          </Button>
          <Box
            component={motion.div}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.97 }}
          >
            <Button
              onClick={handleSaveAddress}
              disabled={saving}
              startIcon={
                saving ? (
                  <CircularProgress size={16} sx={{ color: "#fff" }} />
                ) : (
                  <AddRoundedIcon />
                )
              }
              sx={{
                px: 3.5,
                py: 1.1,
                borderRadius: 999,
                color: "#fff",
                fontWeight: 700,
                background: REDGRAD,
                boxShadow: "0 12px 26px rgba(183,28,28,0.32)",
                "&:hover": {
                  background: REDGRAD,
                  boxShadow: "0 16px 34px rgba(183,28,28,0.45)",
                },
                "&.Mui-disabled": {
                  color: "rgba(255,255,255,0.85)",
                  background: "linear-gradient(135deg,#a85a5a,#c97050)",
                },
              }}
            >
              {saving
                ? "Saving..."
                : editingAddress
                ? "Update Address"
                : "Add Address"}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3500}
        onClose={() => setSnackbar((p) => ({ ...p, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          onClose={() => setSnackbar((p) => ({ ...p, open: false }))}
          sx={{ borderRadius: 2, fontWeight: 600 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default CustomerAddress;
